import React from 'react';
import Icon from '../../../components/AppIcon';
import type { IndustryBenchmark } from '../types';

interface IndustryBenchmarksProps {
  benchmarks: IndustryBenchmark[];
}

const IndustryBenchmarks: React.FC<IndustryBenchmarksProps> = ({ benchmarks }) => {
  return (
    <section className="bg-surface py-12 lg:py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-text-primary mb-4">
            Industry Benchmarks
          </h2>
          <p className="text-lg text-text-secondary max-w-3xl mx-auto">
            See how automation is transforming businesses across different industries
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {benchmarks.map((benchmark, index) => (
            <div
              key={index}
              className="bg-card rounded-lg shadow-md border border-border p-6 hover:shadow-lg transition-shadow duration-fast"
            >
              <h3 className="text-xl font-bold text-text-primary mb-4">{benchmark.industry}</h3>

              <div className="space-y-4 mb-6">
                <div className="flex items-center justify-between">
                  <span className="text-sm text-text-secondary">Avg. Time Saved</span>
                  <span className="text-lg font-bold text-success">{benchmark.avgTimeSaved}</span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-sm text-text-secondary">Cost Reduction</span>
                  <span className="text-lg font-bold text-success">
                    {benchmark.avgCostReduction}
                  </span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-sm text-text-secondary">Adoption Rate</span>
                  <span className="text-lg font-bold text-primary">{benchmark.adoptionRate}</span>
                </div>
              </div>

              <div>
                <div className="flex items-center space-x-2 mb-3">
                  <Icon name="Zap" size={16} className="text-accent" />
                  <span className="text-sm font-medium text-text-primary">
                    Common Automations
                  </span>
                </div>
                <div className="space-y-2">
                  {benchmark.commonAutomations.map((automation, idx) => (
                    <div key={idx} className="flex items-start space-x-2">
                      <Icon name="Check" size={14} className="text-success mt-0.5 flex-shrink-0" />
                      <span className="text-sm text-text-secondary">{automation}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default IndustryBenchmarks;